<template>
  <div>
    <propertyInputComponent v-if="policyGroupObject" ref="propertyInputComponent"
                            v-bind:customer-id="customerId"
                            v-bind:default-property-id="policyGroupObject.property_id"
                            v-bind:emit-events="true"
                            v-on:property-deleted="handlePropertyDeleted"
                            v-on:property-selected="handlePropertySelected"/>
    <propertyInputComponent v-else ref="propertyInputComponent"
                            v-bind:customer-id="customerId"
                            v-bind:emit-events="true"
                            v-on:property-deleted="handlePropertyDeleted"
                            v-on:property-selected="handlePropertySelected"/>
    <div v-if="addressIsUncertain">
      <span>Er kon niet automatisch een geschikt pand gevonden worden voor:</span>
      <div v-html="sanitizedFormattedAddress"></div>
      <span>Controleer de gegevens</span>
    </div>
  </div>
</template>
<script>
import propertyInputComponent from "~/modules/property/components/PropertyInputComponent"
import policyGroupApi from "~/api/policy_group"
import DOMPurify from "dompurify";

export default {
  name: "PolicyGroupPropertyComponent",
  components: {
    propertyInputComponent
  },
  props: {
    policyGroupId: {
      type: Number,
      required: false,
      default: null
    },
    policyGroup: {
      type: Object,
      required: false,
      default: null
    },
    customerId: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data() {
    return {
      policyGroupObject: this.policyGroup,
      mounted: false
    };
  },
  computed: {
    addressIsUncertain() {
      if (this.policyGroupObject !== null) {
        return this.policyGroup.unclear_address === true;
      }
    },
    sanitizedFormattedAddress () {
      if (this.policyGroupObject !== null) {
        return DOMPurify.sanitize(this.policyGroupObject.formatted_values_address)
      }

      return null;
    }
  },
  mounted() {
    if (this.policyGroup === null && this.policyGroupId !== null) {
      policyGroupApi.findById(this.policyGroupId, ['values']).then(response => {
        this.policyGroupObject = response.data
        this.mounted = true
      })
    } else {
      this.mounted = true
    }
  },
  methods: {
    handlePropertyDeleted() {
      if (this.policyGroupObject !== null) {
        policyGroupApi
            .updatePolicyValuesByProperty(this.policyGroupObject.id, 'no-property')
            .finally(() => {
              this.$refs.propertyInputComponent.handleShowPropertyCreate();
            })
      }
    },
    handlePropertySelected(property) {
      if (this.policyGroupObject !== null) {
        policyGroupApi
            .updatePolicyValuesByProperty(this.policyGroupObject.id, property.id).then(response => {
              if (response.data.success === true) {
                policyGroupApi.findById(this.policyGroupObject.id, ['values']).then(response => {
                  this.policyGroup = response.data
                })
              }
            }
        )
      }
    },
  }
}
</script>
<style scoped>
</style>
